import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithMutation, atomWithQuery, queryClientAtom } from 'jotai-tanstack-query';

import { getAutoConversionPusdtApi, postAutoConversionPusdtApi } from '@flipster/apis/v1/earn';
import { PostAutoConversionParams } from '@flipster/apis/v1/earn/types';

const autoConversionPusdtQueryKey = ['getAutoConversionPusdtApi'];

export const pusdtAutoConversionBunja = bunja(() => {
  const getAutoConversionPusdtAtom = atomWithQuery(() => ({
    queryKey: autoConversionPusdtQueryKey,
    queryFn: getAutoConversionPusdtApi,
    select: (res) => res.data,
  }));

  const isAutoConversionPusdtEnabledAtom = atom((get) => get(getAutoConversionPusdtAtom).data?.enabled);

  const mutateAutoConversionPusdtAtom = atomWithMutation((get) => {
    const queryClient = get(queryClientAtom);

    return {
      mutationFn: postAutoConversionPusdtApi,
      async onMutate(variables: PostAutoConversionParams) {
        await queryClient.cancelQueries({ queryKey: autoConversionPusdtQueryKey });
        const previousData = queryClient.getQueryData(autoConversionPusdtQueryKey);
        queryClient.setQueryData(autoConversionPusdtQueryKey, { data: { enabled: variables.enabled } });
        return { previousData };
      },
      onError(_error, _variables, context) {
        queryClient.setQueryData(autoConversionPusdtQueryKey, context?.previousData);
      },
      onSettled() {
        queryClient.invalidateQueries({ queryKey: autoConversionPusdtQueryKey });
      },
    };
  });

  return { isAutoConversionPusdtEnabledAtom, mutateAutoConversionPusdtAtom };
});
pusdtAutoConversionBunja.debugLabel = 'pusdtAutoConversionBunja';
